// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"83":"ff6920e6","164":"f383f170","518":"10020f65","809":"1c1988bc"}[chunkId] + ".js";
};